import IconContainer from "@/components/ui/icon-container";
import Text from "@/components/ui/text";
import React from "react";

interface Props {
  icon: JSX.Element;
  title: string;
  subtitle: string;
}

const FocusCard: React.FC<Props> = ({ icon, title, subtitle }) => (
  <div
    className="flex flex-col gap-5 w-full rounded-lg p-6 border"
    style={{
      borderImage:
        "radial-gradient(circle at center, var(--border-focus-card-center), var(--border-focus-card-mid), var(--border-focus-card-edge)) 1",
      background:
        "radial-gradient(193.57% 162.69% at -5.11% -3.69%, var(--surface-focus-card-start) 0%, var(--surface-focus-card-end) 100%)",
      boxShadow: "0px 40px 32px 0px var(--shadow-focus-card)",
      backdropFilter: "blur(10px)"
    }}
  >
    <div className="flex flex-col gap-4">
      <IconContainer size="md">{icon}</IconContainer>
      <Text variant="xlH1Medium">{title}</Text>
    </div>
    <Text variant="lgBodySecondary">{subtitle}</Text>
  </div>
);

export default FocusCard;
